export const DsfUploadFile=dsf.defineLazyComponent('DsfUploadFile',()=>require('./uploadFile'));
export const DsfUploadImg=dsf.defineLazyComponent('DsfUploadImg',()=>require('./uploadImg'));
export const DsfUploadPhoto=dsf.defineLazyComponent('DsfUploadPhoto',()=>require('./uploadPhoto'));

export const DsfCustomerImg = dsf.defineAsyncComponent("DsfCustomerImg",() => import(/* webpackChunkName: "platform_form" */ "./customerImg.vue"));
export const pcCropImage = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_form" */ "./cropImage.vue"));
export const pictureCutDialog = Vue.defineAsyncComponent(() => import(/* webpackChunkName: "platform_form" */ "./pictureCutDialog.vue"));
